import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import covImg1 from 'Assets/Bronce.svg'
import covImg2 from 'Assets/Plata.svg'
import covImg3 from 'Assets/Oro.svg'

import SELECTOR from '../../../Redux/selectors'

//import { COVERAGE } from 'Global/constants'
import { COVERAGE_MAPPING } from 'Global/mapping'

import { useWindowDimensions } from 'Components/WindowDimensions'

import Dropdown from './CoverageDropdown'

import { CoverageBlock, CoverageImg, Title } from '../style'

const Coverage = ({ type }) => {
  const device = useWindowDimensions()
  const coverageCategories = useSelector(SELECTOR.COVERAGE_CATEGORIES)
  const [category, setCategory] = useState({})
  const image = covImg1

  const text = COVERAGE_MAPPING[type]

  useEffect(() => {
    if(coverageCategories.length && type){
      setCategory(coverageCategories.find((elem)=>elem.id==type) || {})
    }
  }, [coverageCategories, type]) 


  return (
    <CoverageBlock device={device}>
      <Title>{category.description}</Title>
      <CoverageImg src={image} />
    </CoverageBlock>
  )
}

Coverage.propTypes = {
  type: PropTypes.number,
  changeType: PropTypes.func
}

export default Coverage
